import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    template_dir_uri: process.env.VUE_APP_TEMPLATE_DIR_URI
  },
  mutations: {},
  getters: {
    template_dir_uri: state => {
      return state.template_dir_uri;
    }
  },
  actions: {},
  modules: {}
});
